'use strict';

import React from 'react';
import PropTypes from 'prop-types';
// https://availity.github.io/availity-react/components/block-ui/
import BlockUi from '@availity/block-ui';
import classnames from 'classnames';

import Spinner from "react-bootstrap/Spinner";

const Loader = (props) => {
    // pull out the old react-loader-advanced props and allow new @availity/block-ui props to be passed.
    const {
        children,
        show,
        message,
        size,
        messageStyle, disableDefaultStyles, priority, hideContentOnLoad, contentBlur, foregroundStyle, backgroundStyle, contentStyle, transitionConfig,
        ...rest
    } = props;

    let loadingMessage = "Loading...";
    if (typeof message === "string") {
        loadingMessage = message;
    }

    let sizing;
    if (size) {
        sizing = {
            size: size
        };
    } else {
        sizing = {
            className: "fs-3",
            style: {width: "3rem", height: "3rem"}
        }
    }

    const LoadingSpinner = (
        <Spinner animation="border" role="status" {...sizing}>
            <span className="sr-only visually-hidden">{loadingMessage}</span>
        </Spinner>
    );

    return (
        <BlockUi
            className={classnames("custom-block-ui", props.className)}
            loader={LoadingSpinner}
            blocking={show}
            {...rest} >
            {children}
        </BlockUi>
    );
}

Loader.propTypes = {
    show: PropTypes.bool.isRequired,
    size: PropTypes.oneOf(['sm', 'lg']),
    message: PropTypes.string,
    className: PropTypes.string,
}

export default Loader;